
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.244 22.507a.75.75 0 010-1.5h4.5a.75.75 0 00.75-.75v-1.5a.75.75 0 011.5 0v1.5a2.252 2.252 0 01-2.25 2.25h-4.5zM20.244 7.507a.75.75 0 01-.75-.75v-1.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 010-1.5h4.5a2.252 2.252 0 012.25 2.25v1.5c0 .413-.337.75-.75.75zM10.493 24.006c-.071 0-.143-.005-.214-.016l-8.997-1.285a1.508 1.508 0 01-1.288-1.484V3.728A1.506 1.506 0 011.18 2.26L10.157.044a1.51 1.51 0 011.804 1.147c.022.103.033.209.033.315v21c0 .401-.156.778-.44 1.061a1.49 1.49 0 01-1.061.439zM1.517 3.722l-.024.008.001 17.49 9.002 1.285-.002-21-8.977 2.217zM20.245 16.506a.749.749 0 01-.53-1.28l1.72-1.72h-6.441a.75.75 0 010-1.5h6.439l-1.72-1.72c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53a.749.749 0 011.06 0l3.001 3a.495.495 0 01.045.054.756.756 0 01.137.254.793.793 0 01.035.257.82.82 0 01-.067.279.712.712 0 01-.106.167.44.44 0 01-.042.051l-3 3a.757.757 0 01-.531.218z"}}),_c('path',{attrs:{"d":"M7.869 13.132c-.62 0-1.125-.505-1.125-1.125 0-.573.425-1.05.992-1.117a.74.74 0 01.133-.012 1.128 1.128 0 010 2.254z"}})])
          )
        }
      }
    